// src/utils/TrackingScripts.js
export function loadTrackingScripts() {
  if (process.env.REACT_APP_ENV !== "production") return;

  // Google Analytics tag (gtag.js)
  const gaScript = document.createElement("script");
  gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-LNLPEWZ447";
  gaScript.async = true;
  document.head.appendChild(gaScript);

  const gaInlineScript = document.createElement("script");
  gaInlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-LNLPEWZ447');
  `;
  document.head.appendChild(gaInlineScript);

  // Meta Pixel tag
  const fbScript = document.createElement("script");
  fbScript.innerHTML = `
    !function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){
        n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)
      };
      if(!f._fbq)f._fbq=n;
      n.push=n;
      n.loaded=!0;
      n.version='2.0';
      n.queue=[];
      t=b.createElement(e);t.async=!0;
      t.src=v;
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '748992451412601');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(fbScript);

  // Meta Pixel noscript fallback not needed in SPA context
  console.log("Analytics activated");
}
